import { makeProxyRequest, makeRequest } from '../utils/request';
import { rpc } from './helper';

export const getLanguageStubApi = language =>
  makeProxyRequest(
    'get',
    rpc(`/detail_provider?namespace=stub&q=${language}`),
    true
  );

export const runCodeWithCustomInput = (
  problemType,
  payload,
  verifyTestCases = 'none'
) =>
  makeProxyRequest(
    'post',
    rpc(
      `/code.run?__source=TST&solution_type=${problemType}&verify=${verifyTestCases}`
    ),
    true,
    payload
  );

export const runCodeWithTestCases = payload =>
  makeProxyRequest(
    'post',
    rpc(`/solutions.submit?__source=TST`),
    true,
    payload
  );

export const getTechnologiesApi = () =>
  makeRequest('get', rpc('/get_technologies'));
